import InitBookmark from 'front/shared/assets/scripts/initBookmark'

class TagHeader {
	init() {
		new InitBookmark()
	}
}

export default TagHeader
